exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".registrationForm #g-recaptcha>div{margin:auto}", ""]);

// exports
